import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TableVirtualizer } from '../TableVirtualizer';
import { configureColumnDefs, convertToRowData } from './helper';
export function OverridesDependencies(param) {
    let { organization, project, appList = [] } = param;
    const columnDefs = useMemo(()=>configureColumnDefs(appList, organization, project), [
        appList,
        organization,
        project
    ]);
    const rowData = useMemo(()=>convertToRowData(appList), [
        appList
    ]);
    const pinnedColumns = useMemo(()=>{
        return {
            left: [
                'moduleName'
            ]
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "h-[calc(100vh-240px)] overflow-hidden",
        children: /*#__PURE__*/ _jsx(TableVirtualizer, {
            data: rowData,
            columns: columnDefs,
            pinnedColumns: pinnedColumns
        })
    });
}
